import React, {useState, useEffect, Fragment}  from 'react'
import {Form, Input, Row, Col, Button, Table, message, Select, DatePicker} from 'antd';
import {baseUrl, reqReceivableBills} from '../../api/index'
import {listFormItemLayout, transferDateToValues,} from  '../../utills/common'
import {convertToOptions} from "../../components/options";
import {
    TRANSFER_TYPE_N, TRANSFER_TYPE_D, TRANSFER_TYPE_T, TRANSFER_TYPE_A,
    DELIVERY_TYPE, DELIVERY_TYPE_MIX, DELIVERY_TYPE_HIGHWAY, SETTLEMENT_STATUS
} from "../../utills/constants";
const {RangePicker} = DatePicker;
const {Option} = Select;
function ClientBillList(props) {
    const [settlementStatus, setSettlementStatus] = useState(null);
    const [list, setList] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [total, setTotal] = useState(10);
    useEffect(() => {
        getProducts();
        setSettlementStatus(props.settlementStatus);
    }, [props.settlementStatus]);
    useEffect(() => {
        if (settlementStatus === props.settlementStatus && props.settlementStatus === props.activeKey) {
            getProductsByValues();
        }
    }, [props.activeKey]);
    const getProducts = async (values = {}, pageNum = 1, pageSize = 10) => {
        values.pageNum = pageNum;
        values.pageSize = pageSize;
        values.settlementStatus = props.settlementStatus;
        let result = await reqReceivableBills(values);
        if (result.code == 200) {
            setList(result.data.rows);
            setPageNum(pageNum);
            setTotal(result.data.total);
        } else {
            message.error(result.message)
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        getProductsByValues();
    };
    const getProductsByValues = (pageNum, pageSize) => {
        props.form.validateFields((err, values) => {
            if (!err) {
                transferDateToValues(values, ['billDt', 'settlementDt']);
                getProducts(values, pageNum, pageSize);
            }
        });
    };
    const exportFee = () => {
        const searchData = props.form.getFieldsValue();
        searchData.settlementStatus = props.settlementStatus;
        transferDateToValues(searchData, ['billDt', 'settlementDt']);
        const search = [];
        for (let key of  Object.keys(searchData)) {
            if (searchData[key] != null) {
                search.push('&' + key + '=' + searchData[key])
            }
        }
        let url = baseUrl + "/api/v1/p/receivable/export?" + search.join('');
        window.open(url, "_blank");
    };
    const {getFieldDecorator} = props.form;
    const columns = [
        {
            title: '订单编号',
            dataIndex: 'orderNo',
            fixed: 'left',
            width: 135,
            render: (text, record) => (
                <a onClick={() => props.history.push('/orderInfo', record)}>{text}</a>
            )
        }, {
            title: '运输类型',
            dataIndex: 'deliveryType',
            width: 105,
            render: (text, record) => {
                return DELIVERY_TYPE[text]
            }
        }, {
            title: '提货日期',
            dataIndex: 'collectDt',
        }, {
            title: '集装箱号',
            dataIndex: 'boxNo',
            width: 120,
        }, {
            title: '服务范围',
            dataIndex: 'transferType',
            render: (text, record) => {
                if (DELIVERY_TYPE_MIX.hasOwnProperty(record.deliveryType) && record.deliveryType !== 'D') {
                    return TRANSFER_TYPE_N[text]
                }
                if (record.deliveryType === 'D') {
                    return TRANSFER_TYPE_D[text]
                }
                if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(record.deliveryType)) {
                    return TRANSFER_TYPE_T[text]
                }
                return TRANSFER_TYPE_A[text]
            }
        }, {
            title: '起运地',
            dataIndex: 'originCity',
        }, {
            title: '目的地',
            dataIndex: 'destinationCity',
        }, {
            title: '客户结算价',
            dataIndex: 'settlementPrice',
        }
    ];
    //已出账
    if (props.settlementStatus === 'C') {
        columns.push({
            title: '预付款',
            dataIndex: 'advancePrice',
        }, {
            title: '尾款',
            dataIndex: 'balance',
        }, {
            title: '出账日期',
            dataIndex: 'billDt',
            render: (text) => {
                if (text) {
                    return text.slice(0, 10)
                }
                return ''
            }
        })
    }
    //已结算
    if (props.settlementStatus === 'Y') {
        columns.push({
            title: '结算日期',
            dataIndex: 'settlementDt',
            render: (text) => {
                if (text) {
                    return text.slice(0, 10)
                }
                return ''
            }
        })
    }
    //全部
    if (props.settlementStatus === '') {
        columns.push({
            title: '预付款',
            dataIndex: 'advancePrice',
            render: (text, record) => {
                if (record.settlementStatus !== 'Y') {
                    return text
                }
            }
        }, {
            title: '尾款',
            dataIndex: 'balance',
            render: (text, record) => {
                if (record.settlementStatus !== 'Y') {
                    return text
                }
            }
        }, {
            title: '出账日期',
            dataIndex: 'billDt',
            render: (text) => {
                if (text) {
                    return text.slice(0, 10)
                }
                return ''
            }
        }, {
            title: '结算日期',
            dataIndex: 'settlementDt',
            render: (text) => {
                if (text) {
                    return text.slice(0, 10)
                }
                return ''
            }
        }, {
            title: '状态',
            dataIndex: 'settlementStatus',
            width: 60,
            render: (text, record) => {
                return SETTLEMENT_STATUS[text]
            }
        })
    }
    return <Fragment>
        <Form {...listFormItemLayout} onSubmit={handleSubmit}>
            <Row>
                <Col span={8}>
                    <Form.Item label="订单编号">
                        {getFieldDecorator('orderNo', {})(<Input/>)}
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="集装箱号">
                        {getFieldDecorator('boxNo', {})(<Input/>)}
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="运输类型">
                        {getFieldDecorator('deliveryType', {
                            initialValue: '',
                        })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                            <Option value="">全部</Option>{convertToOptions(DELIVERY_TYPE)}
                        </Select>)}
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="出账日期">
                        {getFieldDecorator('billDt', {})(<RangePicker format="YYYY-MM-DD"
                                                                      style={{width: '100%'}}/>)}
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="结算日期">
                        {getFieldDecorator('settlementDt', {})(<RangePicker format="YYYY-MM-DD"
                                                                            style={{width: '100%'}}/>)}
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Button className='margin-btn-last' type='primary' htmlType="submit"
                            style={{float: 'right'}}>查询</Button>
                    <Button className='margin-btn' htmlType="button" style={{float: 'right'}}
                            onClick={exportFee}>导出</Button>
                </Col>
            </Row>
        </Form>
        {props.settlementStatus === 'C' || props.settlementStatus === 'Y' ?
            <Table
                columns={columns}
                bordered
                dataSource={list}
                rowKey='id'
                scroll={{x: 1140}}
                pagination={{
                    current: pageNum,
                    total: total,
                    showQuickJumper: true,
                    onChange: (pageNum) => getProductsByValues(pageNum)
                }}
                size="middle"
            /> :
            <Table
                columns={columns}
                bordered
                dataSource={list}
                rowKey='id'
                scroll={{x: 1350}}
                pagination={{
                    current: pageNum,
                    total: total,
                    showQuickJumper: true,
                    onChange: (pageNum) => getProductsByValues(pageNum)
                }}
                size="middle"
            />}
    </Fragment>
}
export default Form.create()(ClientBillList);